export function passwordIsValid(str) {
  return str.length > 0;
}

export function getPasswordErrorMessage(str) {
  return str === '' ? 'required' : '';
}



// WEBPACK FOOTER //
// ./src/modules/signupForm/utils/password.js